import { PhoneMissed, TrendingUp, CalendarCheck, Clock } from "lucide-react";

const benefits = [
  {
    icon: PhoneMissed,
    metric: "0",
    title: "Reduce Missed Calls",
    description: (<>Every call is answered on the first ring — day or night, weekdays<br className="hidden lg:inline" /> or weekends. No more lost customers to voicemail.</>),
    gradient: "from-blue-500 to-blue-600",
  },
  {
    icon: TrendingUp,
    metric: "+40%",
    title: "Capture More Leads",
    description: (<>Every enquiry is logged with full contact details and service requests.<br className="hidden lg:inline" /> Your pipeline fills up without lifting a finger.</>),
    gradient: "from-green-500 to-green-600",
  },
  {
    icon: CalendarCheck,
    metric: "Auto",
    title: "Smart Booking",
    description: (<>Customers book directly during the call.<br className="md:hidden" /> No email chains, no callbacks,<br className="hidden lg:inline" /> no manual scheduling.</>),
    gradient: "from-amber-500 to-amber-600",
  },
  {
    icon: Clock,
    metric: "3hrs",
    title: "Save Staff Time Daily",
    description: (
      <>Make confident decisions about staffing and focus.<br className="hidden lg:inline" /> Allocate your team's time to the customers in front of them, not the phone.</>
    ),
    gradient: "from-purple-500 to-purple-600",
  },
];

export default function BenefitsSection() {
  return (
    <section id="benefits" data-testid="benefits-section" className="relative py-10 md:py-[85px] bg-[#0F172A] grain-overlay overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-blue-500/5 rounded-full blur-3xl" />

      <div className="section-container relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-medium uppercase tracking-widest text-[#3B82F6] mb-4">
            Benefits
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight text-balance">
            The Impact on Your Business
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-400 max-w-2xl mx-auto leading-relaxed">
            Businesses using AICallFront answer every call, capture every lead, and book more appointments — without hiring extra staff.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={benefit.title}
                className="relative bg-white/[0.04] backdrop-blur-sm border border-white/[0.08] rounded-2xl p-6 md:p-8 hover:bg-white/[0.07] transition-all duration-300 overflow-hidden group"
                data-testid={`benefit-card-${index}`}
              >
                <div className="absolute -top-4 -right-4 opacity-5 group-hover:opacity-10 transition-opacity">
                  <span className="font-heading font-bold text-[120px] text-white leading-none">{benefit.metric}</span>
                </div>

                <div className="relative z-10">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${benefit.gradient} flex items-center justify-center mb-5 shadow-lg`}>
                    <Icon className="w-6 h-6 text-white" strokeWidth={1.5} />
                  </div>
                  <div className="flex items-baseline gap-3 mb-3">
                    <span className="font-heading font-bold text-3xl text-white">{benefit.metric}</span>
                    <h3 className="font-heading font-semibold text-lg text-white">{benefit.title}</h3>
                  </div>
                  <p className="text-sm text-slate-400 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
